import { HttpClient } from '@angular/common/http'
import { Component } from '@angular/core'
import {
  AlertController,
  IonicPage,
  LoadingController,
  ModalController,
  NavController,
  NavParams,
  PopoverController,
  ViewController
} from 'ionic-angular'
import * as moment from 'moment/moment.js'

import { RdkDatePickerComponent } from '../../components/rdk-date-picker/rdk-date-picker'
import { Contact, Deal, DealStatus, User } from '../../models/models'
import { ApiProvider } from '../../providers/api/api'
import { CallsProvider } from '../../providers/api/calls.provider'
import { SettingsProvider } from './../../providers/settings/settings'

@IonicPage()
@Component({
  selector: 'page-add-call',
  templateUrl: 'add-call.html',
})
export class AddCallPage {

  title = "Pianifica chiamata"
  contact: Contact
  meetingDate: moment.Moment
  meetingTime: string
  meetingNotes: string
  deal: Deal

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private api: ApiProvider,
    private modalCtrl: ModalController,
    private popoverCtrl: PopoverController,
    private viewController: ViewController,
    private alertCtrl: AlertController,
    public http: HttpClient,
    private loading: LoadingController,
    private settings: SettingsProvider,
    // private userAuth: UserAuthProvider<User>,
    private callsProvider: CallsProvider) {
    this.contact = (navParams && navParams.get('contact')) || null
    this.deal = (navParams && navParams.get('deal')) || null
    this.meetingNotes = (navParams && navParams.get('notes')) || null

    if (this.deal) {
      this.title = "Ricrea Appuntamento"
    }
  }

  selectDate(event) {
    let now = this.meetingDate ? this.meetingDate : moment().hour(0).minute(0).second(0)
    let __this = this
    var datePicker = new RdkDatePickerComponent(this.modalCtrl, this.popoverCtrl, this.viewController, new NavParams({ currentMoment: now }));
    datePicker.onDateSelected.subscribe(function (date) {
      __this.meetingDate = date.momentDate;
    });
    datePicker.showCalendar(event);

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AddMeetingPage');
  }

  close() {
    this.viewController.dismiss(null);
  }

  createMeeting() {
    if (this.meetingDate && this.meetingTime) {
      const hour = Number(this.meetingTime.split(":")[0]) || 0
      const minute = Number(this.meetingTime.split(":")[1]) || 0
      this.meetingDate.set('hour', hour)
      this.meetingDate.set('minute', minute)

      let loading = this.loading.create({
        content: "Attendere.."
      })

      loading.present()

      this.callsProvider.createCall(this.deal.id, this.meetingDate.toISOString(), this.meetingNotes)
      .switchMap(_meeting => {
        if (this.deal.status === DealStatus.WON) {
          throw new Error('Deal Gia Vinto')
        }
        this.deal.status = this.settings.DEAL_OPEN
        return this.api.patchDeal(this.deal)
      })
      .subscribe(_x => {
        loading.dismiss()
        this.alertCtrl.create({
          title: "Chiamata pianificata",
          message: "Chiamata pianificata correttamente",
          buttons: [
            {
              text: 'Ok',
              handler: () => {
                this.viewController.dismiss(this.meetingDate);
              }
            },
          ]
        }).present()
      }, _e => {
        loading.dismiss()

        this.alertCtrl.create({
          title: "Attenzione",
          message: "Si è verificato un errore durante la creazione della chiamata.",
          buttons: [
            {
              text: 'Annulla',
              handler: () => {
                this.viewController.dismiss(null);
              }
            },
            {
              text: 'Riprova',
              handler: () => {
                this.createMeeting()
              }
            },
          ]
        }).present()

      })
    } else {
      this.alertCtrl.create({
        title: "Attenzione",
        message: "Inserisci una data e orario corretta per continuare",
        buttons: [
          {
            text: 'Ok',
            handler: () => { }
          },
        ]
      }).present()
    }
  }

  // postOnAc(contact_email: string, operator_email: string, meeting_date: string, meeting_time: string) {
  //   let url = "https://mypushop.activehosted.com/proc.php?u=9&f=9&s=&c=0&m=0&act=sub&v=2&jsonp=true"
  //     + "&email=" + contact_email
  //     + "&fullname=" + ""
  //     + "&field[27]=" + operator_email
  //     + "&field[2]=" + meeting_date
  //     + "&field[7]=" + meeting_time
  //     + "&field[16]=" + meeting_date
  //     + "&field[17]=" + meeting_time
  //   return this.http.post<any>(url, {})
  // }

  postMeetingOnAc(contact: Contact, user: User, meeting_date: string, meeting_time: string) {
    let url = "https://mypushop.activehosted.com/proc.php?u=37&f=37&s=&c=0&m=0&act=sub&v=2&jsonp=true"
      + "&email=" + contact.email
      + "&field[41]=" + contact.company // business name
      + "&field[4]=" + user.firstname // mypushop seller name
      + "&field[26]=" + user.firstname + " " + user.surname // MYP_OPERATORNAME
      + "&field[27]=" + user.email // MYP_OPERATOREMAIL
      + "&field[28]=" + user.phone // MYP_OPERATORPHONE
      + "&field[17]=" + meeting_time // Next Appointment Time
      + "&field[16]=" + meeting_date //Next Appointment Date
      + "&field[2]=" + meeting_date
      + "&field[7]=" + meeting_time
    return this.http.post<any>(url, {})
  }

}




// WEBPACK FOOTER //
// ./src/pages/add-call/add-call.ts